import { AppConfig } from '@gms/app-config';
import { defineStore } from 'pinia';
import { computed, ref, watchEffect } from 'vue';
import { wrapStoreWithActivePinia } from '../composables/wrapStoreWithActivePinia';

const _useConfigStore = defineStore('config', () => {
  const lsConfig = localStorage.getItem("config")
  const config = ref<AppConfig | null>(lsConfig ? JSON.parse(lsConfig) : undefined)
  watchEffect(() => {
    localStorage.setItem('config', JSON.stringify(config.value))
  })
  const fullVersion = ref<string|undefined>(process.env.VUE_APP_VERSION)

  const version = computed(() => {
    if (config.value?.isDev) {
      return fullVersion.value;
    }

    return fullVersion.value?.split('-')[0];
  })

  return { config, fullVersion, version }
});

export const useConfigStore = wrapStoreWithActivePinia(_useConfigStore);
